<template>
    <div class="top_nav">
        <div class="nav_menu" :style="'background: '+panelData.switch_header_color"
             style="color: #fff !important; font-weight: normal !important;">
            <div class="nav toggle">
                <a id="menu_toggle"><i class="fa fa-bars"></i></a>
            </div>
            <nav class="nav navbar-nav">
                <ul class=" navbar-right">
                    <li class="nav-item dropdown open" style="padding-left: 15px;">
                        <a href="javascript:;" :style= "[panelData.switch_header_color !== '' ? {'color' : '#FFF !important'} : '']" class="user-profile dropdown-toggle" aria-haspopup="true"
                           id="navbarDropdown" data-toggle="dropdown" aria-expanded="false">
                            <img :src="logoImage" alt="">{{userData.reseller.full_name}}
                        </a>
                        <div class="dropdown-menu dropdown-usermenu pull-right" aria-labelledby="navbarDropdown">
                            <a class="dropdown-item" href="javascript:;" @click="logout"><i
                                    class="fa fa-sign-out pull-right"></i> Log Out</a>
                        </div>
                    </li>
                </ul>
            </nav>
        </div>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex'

    export default {
        name: "AppHeader",
        data() {
            return {
                balancelimit: 0,
                pinlimit: 0,
                userData: {},
                logoImage: '/new_assets/images/img.jpg',
            }
        },
        created() {
            var encryptedData = this.$store.getters.getUser;
            var decodedString = this.com_DecryptString(encryptedData);
            var userData = JSON.parse(decodedString);
            this.userData = userData;
            var balancelimit = parseInt(userData.reseller.limit_balance * 10000) / 10000;
            this.pinlimit = userData.reseller.limit_pins;
            this.balancelimit = balancelimit;
        },
        methods: {
            logout(e) {
                //loader.hide();
                e.preventDefault();
                let rootObject = this;
                let loginparam = {
                    'jwt_token': '',
                    'redirect_url': 'login',
                };
                rootObject.com_setLoginData(loginparam);
            }
        },
        computed: {
            ...mapGetters({
                panelData: 'getPanelData'
            })
        },
    };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>